
import { RevList } from '@ds/components/List'
import { RevListItem } from '@ds/components/ListItem'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { MODAL_NAMES } from '@config/constants'

import FaqModal from '../Modals/FaqModal'
import PerksModal from '../Modals/PerksModal'
import TechSpecModal from '../Modals/TechSpecModal'

import translations from './AdditionalInfo.translations'

export default {
  components: {
    RevList,
    RevListItem,
    IconChevronRight,
    PerksModal,
    FaqModal,
    TechSpecModal,
  },
  props: {
    listingId: {
      type: Number,
      required: true,
    },
    technicalSpecifications: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
  },
  methods: {
    deployTechSpecModal() {
      openModal(MODAL_NAMES.PRODUCT.TECH_SPECS)
    },

    deployFaqModal() {
      openModal(MODAL_NAMES.PRODUCT.FAQ)
    },

    deployPerksModal() {
      openModal(MODAL_NAMES.PRODUCT.PERKS)
    },
  },
}
